<div class="page-container">
    <div class="page-size-container">
        <span class="page-size-text">Page Size: </span>
        <app-dropdown [formGroup]="form" [model]="pageSizeControl"
            (onChange)="pageSizeChange($event)">
        </app-dropdown>
    </div>
    <div class="nav-button">
        <app-button (click)="onPrevious()" [disabled]="previousStack?.length === 0" text="PREVIOUS"></app-button>
        <app-button (click)="onNext()" [disabled]="nextStack?.length === 0" text="NEXT"></app-button>
    </div>
</div>